<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

/**
 * This script targets all <span> elements within the
 * .sections-custom-service-block .policies-text selectors
 * and adds a 'hide-mobile' class to them when viewed on
 * devices with a viewport width of 768 pixels or less.
 * The script also listens for window resize events to
 * dynamically add or remove the class as needed.
 */

document.addEventListener("DOMContentLoaded", function() {
    // Define the mobile breakpoint in pixels
    const MOBILE_BREAKPOINT = 768;

    /**
     * Toggles the 'hide-mobile' class on targeted <span> elements
     * based on the current viewport width.
     */
    function toggleHideMobileClass() {
        // Select all <span> elements within the specified selectors
        const spans = document.querySelectorAll(".sections-custom-service-block .policies-text span");
        
        // Determine if the current viewport width is at or below the mobile breakpoint
        const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

        spans.forEach(function(span) {
            if (isMobile) {
                // Add the 'hide-mobile' class to hide the element on mobile
                span.classList.add("hide-mobile");
            } else {
                // Remove the 'hide-mobile' class to display the element on larger screens
                span.classList.remove("hide-mobile");
            }
        });
    }

    // Perform the initial check when the page loads
    toggleHideMobileClass();

    /**
     * Debounce function to limit how often a function can fire.
     * This improves performance by reducing the number of times
     * toggleHideMobileClass is called during rapid window resizing.
     * 
     * @param {Function} func - The function to debounce.
     * @param {number} wait - The time to wait in milliseconds.
     * @returns {Function} - The debounced function.
     */
    function debounce(func, wait) {
        let timeout;
        return function(...args) {
            const later = () => {
                clearTimeout(timeout);
                func.apply(this, args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    // Add a debounced resize event listener to handle viewport changes
    window.addEventListener("resize", debounce(toggleHideMobileClass, 150));
});